import { DistanceUnit } from "../../enums/configuration/units";

export const DEFAULT_GRID_SIZE_MM = 500;

// gridText given in meters, gridSize given in cm and then scaled based on resolution
export const mapScaleToValue = (scale: number, roomResolution: number, distanceUnit: DistanceUnit) => {
  const gridSize = DEFAULT_GRID_SIZE_MM / scale;
  const gridInfo = { gridSize: 1000 * roomResolution, gridText: 10 };
  if (distanceUnit === DistanceUnit.METRIC) {
    if (gridSize < 75) {
      gridInfo.gridText = 0.5;
      gridInfo.gridSize = 50 * roomResolution;
    } else if (gridSize < 150) {
      gridInfo.gridText = 1;
      gridInfo.gridSize = 100 * roomResolution;
    } else if (gridSize < 350) {
      gridInfo.gridText = 2;
      gridInfo.gridSize = 200 * roomResolution;
    } else if (gridSize < 750) {
      gridInfo.gridText = 5;
      gridInfo.gridSize = 500 * roomResolution;
    } else {
      gridInfo.gridText = 10;
      gridInfo.gridSize = 1000 * roomResolution;
    }
  } else if (distanceUnit === DistanceUnit.IMPERIAL) {
    // Convert thresholds roughly to maintain similar visual scaling
    if (gridSize < 75) {
      gridInfo.gridText = 2; // 2 ft
      gridInfo.gridSize = 2 * 30.48 * roomResolution; // 2 ft in cm
    } else if (gridSize < 150) {
      gridInfo.gridText = 5; // 5 ft
      gridInfo.gridSize = 5 * 30.48 * roomResolution;
    } else if (gridSize < 350) {
      gridInfo.gridText = 10; // 10 ft
      gridInfo.gridSize = 10 * 30.48 * roomResolution;
    } else if (gridSize < 750) {
      gridInfo.gridText = 20; // 20 ft
      gridInfo.gridSize = 20 * 30.48 * roomResolution;
    } else {
      gridInfo.gridText = 50; // 50 ft
      gridInfo.gridSize = 50 * 30.48 * roomResolution;
    }
  }
  return gridInfo;
};
